/**
 * Catálogo local de productos/servicios.
 * Futuro: productRepository + Supabase.
 */
export const MOCK_PRODUCTS = [
	{
		id: "crear-spa",
		nombre: "Constitución de sociedad SpA",
		descripcion: "Constitución de empresa mediante el sistema Empresa en un Día.",
		precioNeto: 100000,
	},
	{
		id: "modificacion",
		nombre: "Modificación de sociedad",
		descripcion: "Preparación y tramitación de modificación societaria.",
		precioNeto: 120000,
	},
	{
		id: "contabilidad",
		nombre: "Servicio de contabilidad mensual",
		descripcion: "Servicio mensual de contabilidad para pequeñas empresas.",
		precioNeto: 80000,
	},
	{
		id: "direccion",
		nombre: "Dirección tributaria",
		descripcion: "Servicio de dirección tributaria por doce meses.",
		precioNeto: 150000,
	},
	{
		id: "termino-giro",
		nombre: "Término de giro",
		descripcion: "Preparación y tramitación de término de giro ante el SII.",
		precioNeto: 110000,
	},
	{
		id: "personalizado",
		nombre: "Servicio personalizado",
		descripcion: "",
		precioNeto: 0,
	},
];

export const MAX_QUOTE_ITEMS = 5;

export const getProductById = (id) =>
	MOCK_PRODUCTS.find((product) => product.id === id) || null;
